<template>
	<div>
		<tabs :tab-name="tabs" :tab-icon="['pages','question_answer', 'assignment']" class="page-subcategories md-layout md-layout-item md-size-100" nav-pills-icons plain color-button="accent">

			<template slot="tab-pane-1" style="width: 100%">
				<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>

				<div class="md-layout" v-if="(entity.id) && (entity.id !== 'novo')">
					<md-card class="md-layout-item md-size-100">
						<md-card-header class="md-card-header-text md-card-header-accent">
							<div class="card-text">
								<h4 class="title">Conteúdo</h4>
							</div>
						</md-card-header>

						<md-card-content>
							<editor apiKey="jsyigy0isp2ob9v4kmzcj8u5qyoeon50s8vuj2zip2pu5w5l" :init="editorConfig" v-model="editor" @onSaveContent="saveEditor" id="editorTiny"></editor>
						</md-card-content>

						<md-card-actions class="text-center">

						</md-card-actions>
					</md-card>
				</div>
			</template>

			<template slot="tab-pane-2" style="width: 100%">
				<paginated-search v-bind="{ schema: schemaQuestion, searchEntities: searchEntitiesQuestion, openEntity: openEntityQuestion, createEntity: createEntityQuestion }"></paginated-search>
			</template>

			<template slot="tab-pane-3" style="width: 100%">
				<paginated-search v-bind="{ schema: schemaResult, searchEntities: searchEntitiesResult, openEntity: openEntityResult, createEntity: createEntityResult }"></paginated-search>
			</template>
		</tabs>
	</div>
</template>

<script>
	import Article from "@/models/article.model.vue"
	import TestQuestion from "@/models/testQuestion.model.vue"
	import TestResult from "@/models/testResult.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import { Tabs, Modal } from '@/components';
	import Editor from '@tinymce/tinymce-vue';
	import EspressoAux from "@/components/Espresso/EspressoAux.vue";

	import config from "../../config/env.config.js";
	const serverUrl = config.ROOT_API;

	export default {
		components: {
			EntityCard,
			PaginatedSearch,
			Tabs,
			Modal,
			Editor,
		},
		data() {
			//const self = this;
			return {
				entity: {
					id: this.$route.params.id,
					courseId: this.$route.params.courseId,
				},
				editor: "",
				tabs: ['Artigos'],
				schema: Article.getSchema(),
				schemaQuestion: TestQuestion.getSchema(),
				schemaResult: TestResult.getCreateSchema(),
				loading: false,
				editorConfig: {
					plugins: "save emoticons image link media preview table textcolor autosave",
					toolbar: "save restoredraft | undo redo | styleselect bold italic forecolor backcolor | alignleft aligncenter alignright table | outdent indent | image link media | preview emoticons",
					statusbar: false,

					save_onsavecallback: function () { console.log('Saved'); /*self.saveEditor();*/ },
					//Define the image upload
					automatic_uploads: true,
					images_upload_url: `${serverUrl}/v1/article/addImage/${this.$route.params.id}`,
					images_upload_credentials: true,
					file_picker_types: 'image,media',
					file_browser_callback_types: 'image media',
					file_picker_callback: (cb, value, meta) => {
						const input = document.createElement("input");
						const uploadVideo = this.uploadVideo;
						input.setAttribute("type", "file");

						if (meta.filetype === "image") input.setAttribute("accept", "image/*");
						if (meta.filetype === "media") input.setAttribute("accept", "video/*");

						input.onchange = function () {
							const file = this.files[0];

							const reader = new FileReader();
							reader.onload = function () {
								if (meta.filetype === "media") {
									uploadVideo(file).then(videoUrl => {
										cb(videoUrl, { title: file.name });
									});
								}

								if (meta.type === "image") {
									const id = 'blobid' + (new Date()).getTime();
									const blobCache =  Editor.activeEditor.editorUpload.blobCache;
									const base64 = reader.result.split(',')[1];
									const blobInfo = blobCache.create(id, file, base64);
									blobCache.add(blobInfo);

									cb(blobInfo.blobUri(), { title: file.name });
								}
							};
							reader.readAsDataURL(file);
						};

						input.click();
					},

					menu: {},
					resize: false,
					height: 700,
					autosave_interval: "15s",
					init_instance_callback: async (editor) => {
						const entity = await this.readEntity(this.$route.params.id);
						if (entity.content) {
							editor.setContent(entity.content);
						}
					},
				},
			}
		},
		methods: {
			async saveEditor(params) {
				// console.log('tiny', tinymce);
				// console.log('editor', tinymce.activeEditor);
				console.log('save editor params', params);
				// console.log('element', document.getElementById("editorTiny"));
				if (params.content !== "") {
					const info = {
						id: this.entity.id,
						content: params.content,
					};

					const response = await this.updateEntity(info);

					if (response) {
						EspressoAux.showSuccessModal("Texto salvo.");
					}
				}
			},
			async createEntity(entity) {
				this.entity = await Article.create(entity);
				this.$router.replace(`/artigos/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				const response = await Article.getInfo(entityId);
				return response;
			},
			async updateEntity(entity) {
				// console.log('editor', this.editor);
				// console.log('entity', entity);
				// console.log('this.entity', this.entity);
				const dataToUpdate = Object.assign({}, entity);
				// console.log('data', dataToUpdate);
				if (this.editor)
					dataToUpdate.content = this.editor;
				else 
					dataToUpdate.content = this.entity.content;
				console.log('editor content', dataToUpdate.content);
				return Article.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await Article.remove(entityId);
				this.$router.push("/artigos");
			},
			async searchEntitiesQuestion(paginationParameters) {
				const parameters = {
					...paginationParameters,
					articleId: this.entity.id,
				}

				return TestQuestion.search(parameters)
			},
			async openEntityQuestion(entity) {
				this.$router.replace(`/artigos/${this.entity.id}/pergunta/${entity.id}`);
			},
			async createEntityQuestion() {
				this.$router.push(`/artigos/${this.entity.id}/pergunta/novo`);
			},
			async searchEntitiesResult(paginationParameters) {
				const parameters = {
					...paginationParameters,
					articleId: this.entity.id,
				}

				return TestResult.searchEntity(parameters);
			},
			async openEntityResult(entity) {
				this.$router.replace(`/artigos/${this.entity.id}/resultado/${entity.id}`);
			},
			async createEntityResult() {
				this.$router.push(`/artigos/${this.entity.id}/resultado/novo`);
			},
			async uploadVideo(data) {
				const formData = new FormData();
				formData.append("file", data);

				const { value } = await EspressoAux.showLoadingModal(Article.uploadVideo(formData, this.entity.id));
				return value.data.video.videoUrl;
			},
		},
		mounted() {
			if ((this.entity.id) && (this.entity.id !== "novo")) {
				this.tabs.push("Questões");
				this.tabs.push("Resultados");
			}
		}
	};
</script>

<style>
.tab-pane-1,
.tab-pane-2,
.tab-pane-3 {
  width: 100% !important;
}

.mce-notification-error,
.mce-notification-warning {
	display: none;
}

.modal-container {
	box-shadow: none !important;
}

.swal2-container {
	z-index: 99999 !important;
}
</style>
